import "./Home.module.css";
import PlatformHeader from "@/reusable_sections/Header";
import RedefiningYourDrive from "./sections/RedefiningYourDrive";
import CertifiedQualityStandards from "./sections/CertifiedQualityStandards";
import CuratedDelights from "./sections/CuratedDelights";
import WaterPurificationAtHome from "./sections/WaterPurificationAtHome";
import TheSilhouetteGallery from "./sections/TheSilhouetteGallery";
import Testimonials from "./sections/Testimonials";
import AapkaVisionHamariDesign from "./sections/AapkaVisionHamariDesign";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PlatformHeader />
      <RedefiningYourDrive />
      <CertifiedQualityStandards />
      <CuratedDelights />
      <WaterPurificationAtHome />
      <TheSilhouetteGallery />
      <Testimonials />
      <AapkaVisionHamariDesign />
      <Footer />
    </div>;
}